import chunk from 'lodash/chunk';
import flatten from 'lodash/flatten';
import {
  setMonth,
  setYear,
  startOfMonth,
  endOfMonth,
  differenceInCalendarDays,
  addDays,
  getDay,
  subDays,
  setDay,
} from 'date-fns';

const now = new Date();

const getWeeks = ({ month = now.getMonth(), year = now.getFullYear() }) => {
  const monthBegin = startOfMonth(
    setYear(setMonth(setDay(now, 1), month), year),
  );
  const monthEnd = endOfMonth(monthBegin);
  const dayDiff = differenceInCalendarDays(monthEnd, monthBegin) + 1;
  const daysOfTheMonth = [...Array(dayDiff).keys()].map(diff =>
    addDays(monthBegin, diff),
  );
  const days = daysOfTheMonth;
  const firstDay = days[0];
  const lastDay = days[days.length - 1];
  const weekDayOfFirstDay = getDay(firstDay);
  const weekDayOfLastDay = getDay(lastDay);
  const firstWeekOffset = 7 - weekDayOfFirstDay;
  const firstWeek = [
    ...[...Array(7 - firstWeekOffset).keys()]
      .reverse()
      .map(diff => subDays(firstDay, diff + 1)),
    ...days.slice(0, firstWeekOffset),
  ];
  let weeks = [firstWeek, ...chunk(days.slice(firstWeekOffset), 7)];
  const lastWeek = [
    ...weeks.pop(),
    ...[...Array(Math.abs(weekDayOfLastDay - 6)).keys()].map(diff =>
      addDays(lastDay, diff + 1),
    ),
  ];
  weeks = [...weeks, lastWeek];
  const allDays = flatten(weeks); // use lodash flatten because Array.flat() is not supported in Node.js
  return { weeks, days: allDays };
};

export default getWeeks;
